// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { SyntheticEvent } from "react";
import styled, { css } from "styled-components";

type Props = OwnProps;

interface OwnProps extends ExpandStyles<SelectableCardStyles> {
    label?: string | React.ReactElement<any, any>;
    loading?: boolean;
    onSelect: (event: SyntheticEvent) => void;
    selected: boolean;
}

export interface SelectableCardWrapperProps extends InjectableCss<SelectableCardWrapperCssProps> {}
export interface SelectableCardWrapperCssProps {
    selected?: boolean;
}

export const SelectableCardWrapper = styled.div<SelectableCardWrapperCssProps>`
    ${injectCss}
`;

export interface SelectableCardStyles {
    loadingOverlay?: LoadingOverlayProps;
    wrapper?: SelectableCardWrapperProps;
    content?: InjectableCss;
    checkbox?: CheckboxPresentationProps;
}

export const selectableCardStyles: SelectableCardStyles = {
    wrapper: {
        css: css<SelectableCardWrapperCssProps>`
            position: relative;
            display: flex;
            width: 100%;
            height: 100%;
            padding: ${pxToRem(20)};
            border: ${pxToRem(2)} solid ${getColor("common.border")};
            border-radius: ${pxToRem(4)};

            ${({ selected }) => {
                if (selected) {
                    return css`
                        border-color: ${getColor("primary")};
                    `;
                }
            }}
        `,
    },
    loadingOverlay: {
        css: css`
            position: static;
        `,
    },
    content: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;

            a,
            button {
                z-index: 3;
            }
        `,
    },
    checkbox: {
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css}
            padding-bottom: ${pxToRem(15)};
            margin-bottom: ${pxToRem(15)};
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

            &:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border-bottom: 0;
            }

            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
                cursor: pointer;
            }
        `,
    },
};

const SelectableCard: React.FunctionComponent<Props> = ({
    children,
    label,
    onSelect,
    selected,
    loading = false,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(selectableCardStyles, extendedStyles, overridedStyles);

    return (
        <SelectableCardWrapper {...styles.wrapper} selected={selected}>
            <LoadingOverlay {...styles.loadingOverlay} loading={loading}>
                <StyledWrapper {...styles.content}>
                    <Checkbox {...styles.checkbox} checked={selected} onChange={onSelect}>
                        {label || translate("Select")}
                    </Checkbox>
                    {children}
                </StyledWrapper>
            </LoadingOverlay>
        </SelectableCardWrapper>
    );
};

export default SelectableCard;
